"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../utils/dom");
function initializeMapbox() {
    if ('mapboxgl' in window)
        return;
    return Promise.all([
        dom_1.appendStylesheet('https://api.mapbox.com/mapbox.js/v3.0.1/mapbox.css'),
        dom_1.appendStylesheet('https://api.tiles.mapbox.com/mapbox-gl-js/v0.52.0/mapbox-gl.css'),
        dom_1.appendScript('https://api.tiles.mapbox.com/mapbox-gl-js/v0.52.0/mapbox-gl.js'),
        dom_1.appendScript('https://api.mapbox.com/mapbox.js/v3.0.1/mapbox.js'),
        dom_1.appendScript('https://api.mapbox.com/mapbox.js/plugins/turf/v3.0.11/turf.min.js'),
    ]);
}
exports.initializeMapbox = initializeMapbox;
//# sourceMappingURL=mapbox.js.map